import React from 'react';

/**
 * Focuses the count field on arrival at the count step while the shift
 * dialog is open, and again whenever the count locks or unlocks. "Re-count"
 * unlocks it by unmounting the button that had focus, so without this focus
 * would drop to the page (SEL-49); confirming locks it, and the field, where
 * `Enter` confirms the next action, keeps the step's focus. Mirrors
 * `useFocusMethodGroup`'s same-tick race against react-aria's own dialog
 * mount focus: a `setTimeout` deferred to the next macrotask reliably wins
 * where a plain `autoFocus` loses it.
 */
export const useFocusCountField = (
    isModalOpen: boolean,
    isCountLocked: boolean,
): React.RefObject<HTMLInputElement | null> => {
    const inputRef = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        if (!isModalOpen) {
            return;
        }
        const timeout = setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
        return () => clearTimeout(timeout);
    }, [isModalOpen, isCountLocked]);

    return inputRef;
};
